// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".m-label{font-size:14px;color:#828282;font-weight:500}.m-label.clickable{cursor:pointer;font-weight:600;text-decoration:underline}.m-label.clickable:hover{color:#22abf3}.m-label.inline{display:inline-block}\n", ""]);
// Exports
module.exports = exports;
